// extracted by mini-css-extract-plugin
module.exports = {"newscontent-box":"d4","newscontentBox":"d4"};